import styled from 'styled-components';
import { FlexRow } from 'ui-toolkit';

export const StyledIncomingFlexRow = styled(FlexRow)`
  padding-left: 15px;
  padding-bottom: 15px;
  padding-top: 10px;
`;
